<template>
  <AppClientSimpleLayout title="予備校料金プラン購入完了">
    <div class="flex flex-col items-center min-h-screen bg-white px-4 pt-16 pb-16 md:pt-24 md:pb-16">
      <div class="flex flex-col items-center w-full max-w-3xl text-center">
        <h1 class="text-4xl md:text-5xl font-bold mb-10 md:mb-12 leading-tight">
          <span class="md:hidden">予備校料金プラン<br>購入完了</span>
          <span class="hidden md:inline">予備校料金プラン購入完了</span>
        </h1>
        <p class="text-base md:text-lg font-bold leading-8 md:leading-9 mb-12 text-left md:text-center">
          ご購入ありがとうございました。<br>
          登録メールアドレスに届くご案内を必ずご確認ください。
        </p>
        <button
          class="bg-CLIENT_PRIMARY_PINK text-white rounded-md px-8 py-3 font-bold shadow-md transition-all duration-300 hover:bg-CLIENT_PRIMARY_PINK_HOVER"
          type="button"
          @click="onClickedPortalTop">
          ポータルサイトTOPへ
        </button>
      </div>
    </div>
  </AppClientSimpleLayout>
</template>

<script setup>
import AppClientSimpleLayout from '@/Layouts/AppClientSimpleLayout'

const onClickedPortalTop = () => {
  window.location.href = 'https://vt-portal.jp'
}
</script>
